import { Controller } from "stimulus"
import axios from 'axios';
export default class ApplicationController extends Controller {

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    })
  }

  getControllerByElement(element) {
    return this.application.controllers.find(controller => {
      return controller.context.element === element;
    })
  }

  instantiate_controller(identifier) {
    var el = document.createElement('div')
    el.dataset.controller = identifier
    document.body.appendChild(el)
    return new Promise(resolve => {
      setTimeout(() => { // queueMicrotask n'est supporté qu'à partir de Safari 12.1
        resolve(this.getControllerByElement(el))
      }, 1)
    })
  }

  visit(url) {
    window.location = url
  }

  reload_page() {
    this.visit(window.location)
  }

  notify(text) {
    this.getControllerByIdentifier('notifications').notify(text)
  }

  dialog(text, callback = null) {
    this.modal(text, { type: 'dialog' }, callback)
  }

  alert(text, callback = null) {
    this.modal(text, { type: 'alert', caution: 'alert' }, callback)
  }

  confirm(text, callback = null) {
    this.modal(text, { type: 'confirm', caution: 'confirm' }, callback)
  }

  modal(content, options = {}, callback = null) {
    this.instantiate_controller('modals').then(controller => controller.modal(content, options, callback))
  }

  /*
    fetch un partial et remplace l'html du dom_id
    retourne une promise resolve (block then de l'appellant) si http code 200 ou reject (bloc catch de l'appellant) dans le cas contraire
    Ex. this.fetch_partial("tab-partial-view", "/foo/23/bar", "get", null).then(() => console.log("then")).catch(() => console.log("catch"))
    form_data est un objet FormData ou null si le fetch ne porte pas sur un formulaire
  */
  fetch_partial(dom_id, url, method, form_data) {
    return new Promise((resolve, reject) => {
      axios({
        method: method,
        url: url,
        data: form_data
      }).then(response => {
        if (response.status === 200) {
          document.getElementById(dom_id).innerHTML = response.data
          resolve(response.status)
        } else
          reject(response.status)
      })
    })
  }

}